import fetchWrapper from "@/api/fetch-wrapper";
import { CALCULATOR_TYPE } from "@/consts";

export const payByAcquiring = (form) => {
    form.append('type', CALCULATOR_TYPE);
    form.append('send', 'y');
    form.append('payment_action', 'redirect');

    const query = `/.ajax/order.php`;
    
    return fetchWrapper.post(query, form);
}

export const saveWithoutPayment = (form) => {
    form.append('type', CALCULATOR_TYPE);
    form.append('send', 'y');
    form.append('payment_action', 'redirect');
    form.append('without_payment', 'y');

    const query = `/.ajax/order.php`;

    return fetchWrapper.post(query, form);
}

export const payByLink = (form) => {
    form.type = CALCULATOR_TYPE;
    form.send = 'y';
    form.payment_action = 'sendLink'
    const query = `/.ajax/order.php`;

    return fetchWrapper.post(query, form);
}